import React from "react"

const RIghtArrow2: React.FC<{ isLeft?: boolean }> = ({ isLeft = false }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={isLeft ? "rotate(180)" : ""}
    >
      <path
        d="M9 18L15 12L9 6"
        stroke="#2F373D"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RIghtArrow2
